import * as THREE from "three";
import Node from './Node';
import Link from './Link';
import Cycle from './Cycle';
import {
    getIntersection,
    getSquare,
    polyPoint
} from "../Helpers/functions";
import {Geometry, Vector2, Vector3} from "three";
import {sendRedrawSimpleEvent} from "../Helpers/Events";

class Plan{
    constructor(){
        this.nodes = [];
        this.links = [];
        this.loop = [];
        this.loops = [];
        this.cycles = [];

        this.walls = [];
        this.defaultWalls = [];

        this.virtualNode = null;
        this.virtualLink = null;

        this.restored = false
        this.offsetX = 0
        this.offsetY = 0
        this.ratio = 1
        this.zoom = 1
        this.canvasCenter = new THREE.Vector2(0,0)


        this.loadedImagesURLs = []
        this.loadedImages = []
        this.queueImages = []
    }

    putNode(node){
        node.x = Math.round(node.x)
        node.y = Math.round(node.y)
        if(!this.virtualNode){
            this.nodes.push(node);
            this.virtualNode = new Node(node.x,node.y);
            this.virtualLink = new Link(node,this.virtualNode);
        }
        else{
            this.nodes.push(node);
            if (
                this.virtualLink.a.x !== this.virtualLink.b.x ||
                this.virtualLink.a.y !== this.virtualLink.b.y
            )
                this.links.push(this.virtualLink);
            this.virtualNode = new Node(node.x,node.y);
            this.virtualLink = new Link(node,this.virtualNode);
        }
        this.calcGraphLoop();
    }

    mergeNode(n1,n2,position='last'){
        switch(position){
            case 'last':{
                this.links.map(l=>{
                    if(l.a === n1) l.a=n2;
                    if(l.b === n1) l.b=n2;
                });
                this.nodes = this.nodes.filter(n=>n!==n1);
                break;
            }
            case 'first':{
                this.links.map(l=>{
                    if(l.a === n2) l.a=n1;
                    if(l.b === n2) l.b=n1;
                });
                this.nodes = this.nodes.filter(n=>n!==n2);
                break;
            }
            case 'center':{
                n2.setX((n1.x+n2.x)/2);
                n2.setY((n1.y+n2.y)/2);
                this.links.map(l=>{
                    if(l.a === n1) l.a=n2;
                    if(l.b === n1) l.b=n2;
                });
                this.nodes = this.nodes.filter(n=>n!==n1);
                break;
            }
        }
        this.clearTwins();
        this.calcGraphLoop();
    }
///////////////////// Удаляет дубликаты стен ///////////////////////////////////////////////////
    clearTwins(){
        const newLinks = []
        this.links.map(l=>{
            const double = newLinks.find(lnk=> {
                if(
                    (l.a === lnk.a && l.b === lnk.b) ||
                    (l.a === lnk.b && l.b === lnk.a)
                ) return true;
                else return false
            })
            if(!double) newLinks.push(l);
        })
        this.links = newLinks;
        this.nodes = this.nodes.filter(n=>this.links.find(l=>l.a===n||l.b===n));
    }
/////////////////////////////////////////////////////////////////////////////////////////////////
    clearEmptyNodes(){
        this.nodes = this.nodes.filter(n=>{
            return this.links.find(l=>l.a===n || l.b===n);
        })
    }
//////////////////////// Поиск комнат //////////////////////////////////////////////////////////////////////
    calcGraphLoop(storeFloor = false, wallsOnly = false) {
        // let start, end
        // start = new Date().getTime()
        this.setWalls(true)
        let linksFiltered = []
        this.links.forEach(link => {
            linksFiltered.push({
                a:{x:link.a.x,y:link.a.y,walls:new Array(link.a.walls.length).fill(0)},
                b:{x:link.b.x,y:link.b.y,walls:new Array(link.b.walls.length).fill(0)},
                rA1:JSON.parse(JSON.stringify(link.rA1)),
                rA2:JSON.parse(JSON.stringify(link.rA2)),
                rB1:JSON.parse(JSON.stringify(link.rB1)),
                rB2:JSON.parse(JSON.stringify(link.rB2)),
            })
        })
        this.setWalls()
        if (wallsOnly)
            return

        // console.log('this.links',this.links)
        // console.log('this.defaultWalls',this.defaultWalls)
        // console.log('nodesFiltered',nodesFiltered)
        // console.log('linksFiltered',linksFiltered)

        const loops = []
        const loopsNodes = []

        linksFiltered.forEach((wall,index) => {
            searchLoop(index,'A')
            searchLoop(index,'B')
        });
        // if (linksFiltered.length > 2)
        //     searchLoop(0,'A')
        function searchLoop(wallIndex,ab) {
            let loop = []
            let loopNodes = []
            loop.push(new Node(linksFiltered[wallIndex]['r'+ab+'1'].x,linksFiltered[wallIndex]['r'+ab+'1'].y))
            loop.push(new Node(linksFiltered[wallIndex]['r'+ab+'2'].x,linksFiltered[wallIndex]['r'+ab+'2'].y))
            loopNodes.push(linksFiltered[wallIndex].a)
            loopNodes.push(linksFiltered[wallIndex].b)

            const nodeVisited = {x:-9999999999999, y:-9999999999999}
            const __linksFiltered = JSON.parse(JSON.stringify(linksFiltered))
            // console.log('wallIndex',wallIndex)
            // console.log('__linksFiltered',__linksFiltered)

            __linksFiltered[wallIndex]['r'+ab+'1'] = nodeVisited
            __linksFiltered[wallIndex]['r'+ab+'2'] = nodeVisited

            // console.log('loop[0]',loop[0])
            // console.log('loop[1]',loop[1])
            for (let i=0; i < linksFiltered.length*4; i++) {
                for (let j=0; j < __linksFiltered.length; j++) {
                    const wall = __linksFiltered[j]
                    const rA1 = new Node(wall.rA1.x,wall.rA1.y)
                    const rA2 = new Node(wall.rA2.x,wall.rA2.y)
                    const rB1 = new Node(wall.rB1.x,wall.rB1.y)
                    const rB2 = new Node(wall.rB2.x,wall.rB2.y)
                    const _lastPoint = loop[loop.length-1]
                    let found = false
                    if (_lastPoint.equals(rA1)) {
                        loop.push(rA2)
                        loopNodes.push(wall.b)
                        found = true

                        __linksFiltered[j].rA1 = nodeVisited
                        __linksFiltered[j].rA2 = nodeVisited

                        if (wall.b.walls.length === 1) {
                            loopNodes.push(wall.b)
                            loopNodes.push(wall.a)
                            loop.push(rB2)
                            loop.push(rB1)

                            __linksFiltered[j].rB1 = nodeVisited
                            __linksFiltered[j].rB2 = nodeVisited
                        }
                    } else if (_lastPoint.equals(rA2)) {
                        loop.push(rA1)
                        loopNodes.push(wall.a)
                        found = true

                        __linksFiltered[j].rA1 = nodeVisited
                        __linksFiltered[j].rA2 = nodeVisited

                        if (wall.a.walls.length === 1) {
                            loopNodes.push(wall.a)
                            loopNodes.push(wall.b)
                            loop.push(rB1)
                            loop.push(rB2)

                            __linksFiltered[j].rB1 = nodeVisited
                            __linksFiltered[j].rB2 = nodeVisited
                        }
                    } else if (_lastPoint.equals(rB1)) {
                        loop.push(rB2)
                        loopNodes.push(wall.b)
                        found = true

                        __linksFiltered[j].rB1 = nodeVisited
                        __linksFiltered[j].rB2 = nodeVisited

                        if (wall.b.walls.length === 1) {
                            loopNodes.push(wall.b)
                            loopNodes.push(wall.a)
                            loop.push(rA2)
                            loop.push(rA1)

                            __linksFiltered[j].rA1 = nodeVisited
                            __linksFiltered[j].rA2 = nodeVisited
                        }
                    } else if (_lastPoint.equals(rB2)) {
                        loop.push(rB1)
                        loopNodes.push(wall.a)
                        found = true

                        __linksFiltered[j].rB1 = nodeVisited
                        __linksFiltered[j].rB2 = nodeVisited

                        if (wall.a.walls.length === 1) {
                            loopNodes.push(wall.a)
                            loopNodes.push(wall.b)
                            loop.push(rA1)
                            loop.push(rA2)

                            __linksFiltered[j].rA1 = nodeVisited
                            __linksFiltered[j].rA2 = nodeVisited
                        }
                    }
                    if (found) break
                }
                // console.log('loop',loop)
                if (loop.length > 2 && loop[0].equals(loop[loop.length-1])) {

                    loop.pop()
                    loopNodes.pop()

                    const isCopy = loops.find(_l => {
                        const loop_1 = _l.slice()
                        const loop_2 = loop.slice()
                        loop_1.sort((a,b) => {
                            return a.x - b.x || a.y - b.y
                        })
                        loop_2.sort((a,b) => {
                            return a.x - b.x || a.y - b.y
                        })
                        // console.log('loop_1',loop_1)
                        // console.log('loop_2',loop_2)
                        let result = true
                        if (loop_1.length !== loop_2.length) {
                            result = false
                        } else {
                            loop_1.forEach((point, i) => {
                                if (loop_1[i].x !== loop_2[i].x || loop_1[i].y !== loop_2[i].y)
                                    result = false
                            })
                        }

                        return result
                    })

                    if (undefined === isCopy) {
                        loops.push(loop)
                        loopsNodes.push(loopNodes)
                    }
                    break
                }
            }
        }

        const outerLoops = []
        loops.forEach((loop,index) => {
            this.nodes.forEach(node => {
                if (node.walls.length > 1 && polyPoint(loop, node.x, node.y))
                    outerLoops.push(index)
            })
        })
        const loopsResult = loops.filter((el,index) => {
            if (outerLoops.includes(index))
                return false
            else
                return true
        })
        // const loopsNodesResult = loopsNodes.filter((el,index) => {
        //     if (outerLoops.includes(index))
        //         return false
        //     else
        //         return true
        // })


        // console.log('loopsResult',loopsResult)
        // console.log('loopsNodesResult',loopsNodesResult)
        // this.loopsDebug = loopsResult

        const cycles = []
        loopsResult.forEach(loop => {
            cycles.push(new Cycle(loop))
        })

        if (storeFloor) {
            cycles.forEach((cycle, index) => {
                if (this.cycles[index] && this.cycles[index].material)
                    cycle.material = this.cycles[index].material
            })
        }

        this.loops = loopsResult
        this.cycles = cycles

        this.setFloors()

        // end = new Date().getTime()
        // console.log('DFScycle: '+(end-start)+'ms; count:')
    }

    /*OLD__calcGraphLoop(){

        // let start, end
        // start = new Date().getTime()

        let nodesFiltered = this.nodes.slice()
        let linksFiltered = this.links.slice()

        // Отсечение веток для оптимизации //
        const filterNodesAndLinks = (nodes, links) => {
            const __nodesFiltered = nodes.filter(node => {
                const nodeLinks = links.filter(link => node === link.a || node === link.b)
                if (nodeLinks.length > 1) {
                    return true
                } else {
                    linksFiltered = links.filter(link => node !== link.a && node !== link.b)
                    return false
                }
            })
            if (nodesFiltered.length !== __nodesFiltered.length) {
                nodesFiltered = __nodesFiltered
                filterNodesAndLinks(nodesFiltered, linksFiltered)
            }
        }
        filterNodesAndLinks(nodesFiltered, linksFiltered)
        let DFScycleCNT = 0
        const DFScycle = (u,endV,E,color,unavailableEdge,cycle) => {
            DFScycleCNT++

            if (u !== endV)
                color.set(u,2)
            else if (cycle.length >= 2) {
                const duplicate = cycles.find(c => {
                    if (
                        c.join('-') === cycle.join('-') ||
                        c.reverse().join('-') === cycle.join('-')
                    ) {
                        return true
                    }
                    return false
                })
                if (undefined === duplicate)
                    cycles.push(cycle)
                return
            }
            for (let w = 0; w < E.length; w++) {
                if (w === unavailableEdge)
                    continue

                if (color.get(E[w].b) === 1 && E[w].a === u) {
                    let cycleNEW = cycle.concat([this.nodes.findIndex(node => node === u)])
                    DFScycle(E[w].b, endV, E, color, w, cycleNEW)
                    color.set(E[w].b,1)
                } else if (color.get(E[w].a) === 1 && E[w].b === u) {
                    let cycleNEW = cycle.concat([this.nodes.findIndex(node => node === u)])
                    DFScycle(E[w].a, endV, E, color, w, cycleNEW)
                    color.set(E[w].a,1)
                }
            }
        }
        let cycles = []
        const max = nodesFiltered.length
        for (let i = 0; i < max; i++) {
            const color = new WeakMap()
            nodesFiltered.forEach(node => {color.set(node,1)})
            let cycle = []
            // console.log('linksFiltered.length',linksFiltered.length)
            // DFScycle(nodesFiltered[i],nodesFiltered[i],linksFiltered,color,-1,cycle)

            DFScycle(nodesFiltered[0],nodesFiltered[0],linksFiltered,color,-1,cycle)
            linksFiltered = linksFiltered.filter(link => nodesFiltered[0] !== link.a && nodesFiltered[0] !== link.b)
            nodesFiltered.shift()
            // filterNodesAndLinks(nodesFiltered, linksFiltered)

            // break
        }

        // end = new Date().getTime()
        // console.log('DFScycle: '+(end-start)+'ms; count:'+DFScycleCNT)
        // start = new Date().getTime()

        // console.log('cycles',cycles)

        const resultCycles = []
        cycles.forEach(cycle => {
            let notInclude = true
            resultCycles.forEach(_cycle => {
                const _cycleGhost = _cycle.slice()
                const cycleGhost = cycle.slice()
                if (_cycleGhost.sort((a, b) => a - b).join('-') === cycleGhost.sort((a, b) => a - b).join('-'))
                    notInclude = false
            })
            if (notInclude)
                resultCycles.push(cycle)
        })

        // const loops = []
        // resultCycles.forEach(cycle => {
        //     const loop = new Cycle()
        //     let prevNode = cycle.length - 1
        //     for(let i = 0; i < cycle.length; i++){
        //         const node_1 = this.nodes[cycle[prevNode]]
        //         const node_2 = this.nodes[cycle[i]]
        //         const linkID = this.links.findIndex(link => {
        //             if (
        //                 (link.a === node_1 && link.b === node_2) ||
        //                 (link.a === node_2 && link.b === node_1)
        //             ) return true
        //             else return false
        //         })
        //         if (undefined !== linkID)
        //             loop.add(this.links[linkID])
        //
        //         prevNode = i
        //     }
        //     if (loop.length > 0)
        //         loops.push(loop)
        // })

        // console.log('resultCycles',resultCycles)

        this.loops = resultCycles
        this.setFloors()
        // this.loop = loops
        // console.log('resultCycles',resultCycles)

        // Фильтр внешних контуров для других площадей
        // this.loops.filter(floor => {
        //     let goNext = false
        //     const floorThis = floor.slice()
        //     resultCycles.forEach(_floor => {
        //         const floorNext = _floor.slice()
        //         let index_floorThis = floorThis.findIndex(__nodeID => __nodeID === floorNext[0])
        //         for (let i = 0; i < floorNext.length; i++) {
        //             if (floorNext[i] != floorThis[index_floorThis])
        //                 goNext = true
        //             else
        //                 index_floorThis++
        //         }
        //     })
        //     if (goNext)
        //         return false
        //     else
        //         return true
        // })

        // end = new Date().getTime()
        // console.log('DFScycle AFTER: '+(end-start)+'ms')
    }*/
    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    setFloors(){
        this.loops.map((floor, index) => {
            const geometry = new Geometry()
            floor.forEach(node => {
                geometry.vertices.push(
                    new Vector3( node.x,  node.y, 0 )
                )
            })
            geometry.computeBoundingBox()
            floor.square = (Math.round(getSquare(this, floor)/100)/100)
            floor.squareText = floor.square.toString()+' м2'

            // console.log('geometry.boundingBox',geometry.boundingBox)
            floor.texRect = {
                x:geometry.boundingBox.min.x,
                y:geometry.boundingBox.min.y,
                w:geometry.boundingBox.max.x - geometry.boundingBox.min.x,
                h:geometry.boundingBox.max.y - geometry.boundingBox.min.y
            }
            if (floor.square > 0) {
                const imgUrl = this.cycles[index].material.userData.IMAGE
                // console.log('imgUrl',imgUrl)

                const bgImage = new Image;
                bgImage.src = this.getFloorTexture(floor.texRect,imgUrl,floor);
                floor.bgImage = bgImage
                // console.log('floor.bgImage',floor.bgImage)
            }

            floor.diagonalCenter = {x:0,y:0}
            floor.diagonalCenter.x = (geometry.boundingBox.min.x+geometry.boundingBox.max.x)/2
            floor.diagonalCenter.y = (geometry.boundingBox.min.y+geometry.boundingBox.max.y)/2
        })
    }
    getFloorTexture(texRect,imgUrl,floor){

        let dataImage = null

        const {devicePixelRatio: ratio=1} = window

        const canvasFake = document.createElement( 'canvas' )
        const canvasFake2 = document.createElement( 'canvas' )
        const ctxFake = canvasFake.getContext('2d');
        const ctxFake2 = canvasFake2.getContext('2d');
        canvasFake.width = ctxFake.width = texRect.w*ratio
        canvasFake.height = ctxFake.height = texRect.h*ratio
        ctxFake.scale(ratio, ratio)
        canvasFake2.width = ctxFake2.width = texRect.w*ratio
        canvasFake2.height = ctxFake2.height = texRect.h*ratio
        ctxFake2.scale(ratio, ratio)
        // console.log('texRect',texRect)
        // const xN = (texRect.x > 0) ? Math.abs(texRect.x) : 0 - texRect.x
        // const yN = (texRect.y > 0) ? Math.abs(texRect.y) : 0 - texRect.y
        const xN = texRect.x
        const yN = texRect.y

        let bgImage = -1
        const img_id = this.loadedImagesURLs.indexOf(imgUrl)
        if (img_id === -1) {
            this.loadImage(imgUrl)
        } else if (this.isQueueImagesEmpty()) {
            ctxFake2.clearRect(0, 0, canvasFake2.width, canvasFake2.height)
            bgImage = this.loadedImages[img_id]
            const wCount = Math.ceil(ctxFake2.width/(bgImage.width))
            const hCount = Math.ceil(ctxFake2.height/(bgImage.height))
            for (let i = 0; i <= wCount; i++) {
                for (let j = 0; j <= hCount; j++) {
                    const x = i * bgImage.width/ratio
                    const y = j * bgImage.height/ratio
                    ctxFake2.drawImage(bgImage, x, y, bgImage.width/ratio, bgImage.height/ratio)
                }
            }

            ctxFake.clearRect(0, 0, canvasFake.width, canvasFake.height)
            ctxFake.save()
            ctxFake.fillStyle = '#f00'
            ctxFake.strokeStyle = '#f00'
            let first = true
            floor.forEach(p => {
                const x = p.x - xN
                const y = p.y - yN
                const point =  new Node(x,y)
                // console.log('point',point)

                if (first) {
                    first = false
                    ctxFake.beginPath()
                    ctxFake.moveTo(point.x, point.y)
                } else {
                    ctxFake.lineTo(point.x, point.y)
                }
            })
            ctxFake.closePath()
            ctxFake.stroke()
            ctxFake.fill()

            ctxFake.globalCompositeOperation = "source-in"

            ctxFake.drawImage(canvasFake2, 0, 0)

            ctxFake.restore()
            dataImage = canvasFake.toDataURL();
        }
        return dataImage
    }
    loadImage = (imgUrl) => {
        this.loadedImagesURLs.push(imgUrl)
        this.queueImages.push(imgUrl)
        const img_id = this.loadedImages.push(new Image()) - 1
        this.loadedImages[img_id].src = imgUrl
        this.loadedImages[img_id].addEventListener('load', () => {
            const queueImage = this.queueImages.indexOf(imgUrl)
            if(queueImage !== -1)
                delete this.queueImages[queueImage]

            this.setFloors()
        }, false)
    }
    isQueueImagesEmpty = () => {
        var result = true;
        for(var i=0;i<this.queueImages.length;i++){
            if(undefined !== this.queueImages[i]){
                result = false;
                break;
            }
        }
        return result;
    }
    setWalls(defaultH = false){
        const nodes = this.nodes.slice()
        const links = this.links.slice()
        let corners = []
        let walls = []
        nodes.forEach(n=>{
            corners.push(n)
        })
        links.forEach(l => {
            walls.push(l)
        })
        if (
            this.virtualLink &&
            this.virtualLink.a.x === this.virtualLink.b.x &&
            this.virtualLink.a.y === this.virtualLink.b.y
        ) {

        } else {
            if (this.virtualNode) corners.push(this.virtualNode)
            if (this.virtualLink) walls.push(this.virtualLink)
        }

        walls.map(wall => {

            const v = wall.a.clone().sub(wall.b) //вектор стены
            const halfH = (defaultH) ? 2 : wall.h/2

            const __v = v.clone().rotateAround(new Vector2(0,0), 90*(Math.PI/180)).setLength(halfH)
            wall.grA1def = {x:__v.x+wall.a.x,y:__v.y+wall.a.y}
            wall.grB1def = {x:__v.x+wall.b.x,y:__v.y+wall.b.y}

            const __v2 = v.clone().rotateAround(new Vector2(0,0), -90*(Math.PI/180)).setLength(halfH)
            wall.grA2def = {x:__v2.x+wall.a.x,y:__v2.y+wall.a.y}
            wall.grB2def = {x:__v2.x+wall.b.x,y:__v2.y+wall.b.y}

            wall.rA1 = wall.grA1def
            wall.rA2 = wall.grB1def
            wall.rB1 = wall.grA2def
            wall.rB2 = wall.grB2def
        })

        corners.map(corner => {
            corner.walls = walls.filter(wall => corner === wall.a || corner === wall.b)

            // Точки пересечения
            corner.walls.map(wall => {
                if (corner.walls.length > 1) {
                    let endPoint
                    if (corner === wall.a) {
                        endPoint = wall.b
                    } else if (corner === wall.b) {
                        endPoint = wall.a
                    }

                    if (endPoint) {
                        const vector = endPoint.clone().sub(corner)
                        wall.angleValue = vector.angle()
                        wall.endPoint = endPoint
                        wall.vector = vector
                    }
                }

            })
            corner.walls.sort((a,b) => { // Сортировка стен по углу
                return a.angleValue - b.angleValue
            })

            if (corner.walls.length > 1) {

                corner.walls.map(wall => {
                    let v // вектор стены
                    wall.inverted = false // a и b инвертированы?
                    let wallA
                    let wallB
                    if (corner === wall.a) {
                        wallA = wall.b
                        wallB = wall.a
                        wall.inverted = true
                    } else if (corner === wall.b) {
                        wallA = wall.a
                        wallB = wall.b
                    }
                    v = wallA.clone().sub(wallB)

                    const halfH = (defaultH) ? 2 : wall.h/2

                    const __v = v.clone().rotateAround(new Vector2(0,0), 90*(Math.PI/180)).setLength(halfH)
                    const grA1 = {x:__v.x+wallA.x,y:__v.y+wallA.y}
                    const grB1 = {x:__v.x+wallB.x,y:__v.y+wallB.y}

                    const __v2 = v.clone().rotateAround(new Vector2(0,0), -90*(Math.PI/180)).setLength(halfH)
                    const grA2 = {x:__v2.x+wallA.x,y:__v2.y+wallA.y}
                    const grB2 = {x:__v2.x+wallB.x,y:__v2.y+wallB.y}

                    // Вектор стены максимальной длины для пересечения
                    const vBase = v.clone().setLength(1000*this.zoom/2)

                    grA1.x = grA1.x + vBase.x
                    grA1.y = grA1.y + vBase.y
                    grA2.x = grA2.x + vBase.x
                    grA2.y = grA2.y + vBase.y

                    grB1.x = grB1.x - vBase.x
                    grB1.y = grB1.y - vBase.y
                    grB2.x = grB2.x - vBase.x
                    grB2.y = grB2.y - vBase.y

                    wall.grA1 = grA1
                    wall.grA2 = grA2
                    wall.grB1 = grB1
                    wall.grB2 = grB2

                })

                for (let i = 0; i < corner.walls.length; i++) {
                    const wall_1 = corner.walls[i]
                    const wall_2 = (undefined !== corner.walls[i+1]) ? corner.walls[i+1] : corner.walls[0]
                    const wall_0 = (undefined !== corner.walls[i-1]) ? corner.walls[i-1] : corner.walls[corner.walls.length-1]

                    let crossNameA, crossNameB
                    if (corner.walls[i].a === corner) {
                        crossNameA = 'crossAa'
                        crossNameB = 'crossBa'
                    } else if (corner.walls[i].b === corner) {
                        crossNameA = 'crossAb'
                        crossNameB = 'crossBb'
                    }

                    corner.walls[i][crossNameA] = getIntersection(
                        {x:wall_1.grA1,y:wall_1.grB1},
                        {x:wall_2.grA2,y:wall_2.grB2}
                    )
                    if (corner.walls.length < 3) {
                        corner.walls[i][crossNameB] = getIntersection(
                            {x:wall_1.grA2,y:wall_1.grB2},
                            {x:wall_2.grA1,y:wall_2.grB1}
                        )
                    } else {
                        corner.walls[i][crossNameB] = getIntersection(
                            {x:wall_1.grA2,y:wall_1.grB2},
                            {x:wall_0.grA1,y:wall_0.grB1}
                        )
                    }

                    if (corner.walls[i].inverted) {
                        const tmp_crossA = corner.walls[i][crossNameA]
                        const tmp_crossB = corner.walls[i][crossNameB]
                        corner.walls[i][crossNameA] = tmp_crossB
                        corner.walls[i][crossNameB] = tmp_crossA
                    }
                }
            }

        })


        walls.map((wall, index) => {
            const pointA = wall.a
            const pointB = wall.b
            const cornerA = corners.find(corner => corner === pointA)
            const cornerB = corners.find(corner => corner === pointB)
            const cornerA_wall = cornerA.walls.find(wall => {
                return (pointA === wall.a && pointB === wall.b) ||
                    (pointA === wall.b && pointB === wall.a)
            })
            const cornerB_wall = cornerB.walls.find(wall => {
                return (pointA === wall.a && pointB === wall.b) ||
                    (pointA === wall.b && pointB === wall.a)
            })



            const maxDist = 70
            let dist
            if (cornerA.walls.length > 1) {
                if (cornerA_wall.crossAa) {
                    dist = (new Vector2(wall.a.x,wall.a.y)).distanceTo(new Vector2(cornerA_wall.crossAa.x,cornerA_wall.crossAa.y))
                    if (dist < maxDist)
                        wall.rA1 = cornerA_wall.crossAa
                }
                if (cornerA_wall.crossBa) {
                    dist = (new Vector2(wall.a.x,wall.a.y)).distanceTo(new Vector2(cornerA_wall.crossBa.x,cornerA_wall.crossBa.y))
                    if (dist < maxDist)
                        wall.rB1 = cornerA_wall.crossBa
                }
            }
            if (cornerB.walls.length > 1) {
                if (cornerB_wall.crossAb) {
                    dist = (new Vector2(wall.b.x,wall.b.y)).distanceTo(new Vector2(cornerB_wall.crossAb.x,cornerB_wall.crossAb.y))
                    if (dist < maxDist)
                        wall.rA2 = cornerB_wall.crossAb
                }
                if (cornerB_wall.crossBb) {
                    dist = (new Vector2(wall.b.x,wall.b.y)).distanceTo(new Vector2(cornerB_wall.crossBb.x,cornerB_wall.crossBb.y))
                    if (dist < maxDist)
                        wall.rB2 = cornerB_wall.crossBb
                }
            }
        })
        // console.log('corners', corners)
        // console.log('walls', walls)
        // console.log('-----------------------')

        if (defaultH)
            this.defaultWalls = walls
        else
            this.walls = walls
    }
    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    clone(){
        const plan = new Plan();
        plan.nodes = this.nodes;
        plan.links = this.links;
        plan.loop = this.loop;

        plan.virtualNode = this.virtualNode;
        plan.virtualLink = this.virtualLink;
        return plan;
    }
    /////////////////////////////////////////////////////////////////////////////////////////////
    removeWall(wall){
        this.links = this.links.filter(l=>l!==wall);
        this.clearEmptyNodes();
        this.calcGraphLoop();
    }
    cutWall(wall,weight=0.5){
        const objects = wall.objects
        const newNode = wall.a.clone().add(wall.b.clone().sub(wall.a).multiplyScalar(weight));
        this.nodes.push(newNode);
        const newLink = new Link(newNode,wall.b);
        wall.b = newNode;

        const length1 = (Math.ceil((new Vector2(wall.a.x,wall.a.y))
            .distanceTo(new Vector2(wall.b.x,wall.b.y))))

        const objects1 = []
        const objects2 = []
        objects.forEach(obj => {
            const start = obj.pos
            const end = obj.pos + obj.width
            if (start < length1 && end > length1) {
                // объект в точке деления
            } else if (start < length1 && end < length1) {
                objects1.push(obj)
            } else if (start > length1) {
                obj.pos -= length1
                objects2.push(obj)
            }
        })
        wall.objects = objects1
        newLink.objects = objects2

        this.links.push(newLink);
        this.clearTwins();
        this.calcGraphLoop();
    }
    toOBJ(){
        const result = {};
        result.nodes = this.nodes.map(n=>({x:n.x,y:n.y}));
        result.links = this.links.map(l=>({
            a: this.nodes.indexOf(l.a),
            b: this.nodes.indexOf(l.b),
            h: l.h,
            height: l.height,
            leftSide: l.leftSide.userData.ID,
            rightSide: l.rightSide.userData.ID,
            objects: l.objects.map(o => ({
                height: o.height,
                width: o.width,
                position: 0,
                pos: o.pos,
                isDoor: o.isDoor,
                isWindow: o.isWindow,
                padding: o.padding,
                heightFromFloor: o.heightFromFloor
            }))
        }));
        result.links.map(link => {
            console.log('link.objects',link.objects)
        })
        // result.loop = this.loop.map(l=>l.material.userData.ID);
        result.cycles = this.cycles.map(l=>l.material.userData.ID)
        result.offsetX = this.offsetX
        result.offsetY = this.offsetY
        result.zoom = this.zoom
        result.ratio = this.ratio
        result.canvasCenter = this.canvasCenter
        console.log('this',this)
        console.log('result',result)
        return result;
    }
}

export default Plan;
